<lib-input-base
  label="{{ '#HARDWARE_MANAGEMENT.FORM.HARDWARETYP.LABEL' | translate }}"
  controlName="hardwaretyp"
  [required]="required"
  (valueChange)="valueChanged($event)"
  (select)="select($event); inputBase.isOpen$.next(false)"
  (formReset)="resetForm($event)"
  (edit)="edit($event)"
  [entities]="(products$ | async) ?? []"
  [editing]="typInEditing$ | async"
  [formGroup]="formGroup"
  [readonly]="readonly"
  [entityEditTemplate]="editTemplate"
  [entityResultTemplate]="resultTemplate"
  [entityCreateTemplate]="createTemplate"
  [selectedTemplate]="selectedTemplate"
  [filter]="filterTypes"
  #inputBase>
</lib-input-base>

<ng-template #selectedTemplate let-entity>
  {{ entity?.id }} - {{ entity?.typ }}
</ng-template>

<ng-template #editTemplate let-productInEditing>
  <form [formGroup]="typEditingForm" class="flex flex-col px-4 py-4 gap-4">
    <soft-input placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.HARDWARETYP.LABEL' | translate }}" formControlName="typ"></soft-input>
    <soft-input placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.COMMON.BEZEICHNUNG' | translate }}" formControlName="bezeichnung"></soft-input>
    <soft-input placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.COMMON.BESCHREIBUNG' | translate }}" formControlName="beschreibung"></soft-input>
    <div class="flex w-full items-center justify-between">
      <a class="soft-link" (click)="resetForm(productInEditing)">{{ '#HARDWARE_MANAGEMENT.FORM.ACTIONS.RESET' | translate }}</a>
      <button class="soft-button primary" type="submit" (click)="saveEdit(productInEditing)">{{ '#HARDWARE_MANAGEMENT.FORM.ACTIONS.SAVE' | translate }}</button>
    </div>
  </form>
</ng-template>


<ng-template #createTemplate>
  <form [formGroup]="typEditingForm" class="flex flex-col px-4 py-4 gap-4">
    <soft-input placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.HARDWARETYP.LABEL' | translate }}" formControlName="typ"></soft-input>
    <soft-input placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.COMMON.BEZEICHNUNG' | translate }}" formControlName="bezeichnung"></soft-input>
    <soft-input placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.COMMON.BESCHREIBUNG' | translate }}" formControlName="beschreibung"></soft-input>
    <div class="flex w-full items-center justify-between">
      <a class="soft-link" (click)="resetForm()">{{ '#HARDWARE_MANAGEMENT.FORM.ACTIONS.RESET' | translate }}</a>
      <button class="soft-button primary" type="submit" (click)="create(typEditingForm.value)">{{ '#HARDWARE_MANAGEMENT.FORM.ACTIONS.SAVE' | translate }}</button>
    </div>
  </form>
</ng-template>

<ng-template #resultTemplate let-entity>
  <div class="grid" style="grid-template-columns: auto 2.5rem">
    <div class="!flex w-full flex-col justify-center border-r border-r-secondary border-solid py-2 pr-4 text-ellipsis overflow-hidden" (click)="select(entity); inputBase.isOpen$.next(false)">
      <strong [title]="$safeNavigationMigration(entity?.typ)" class="text-ellipsis overflow-hidden">{{ entity.typ }}</strong>
      <div class="text-sm opacity-75 text-ellipsis overflow-hidden">{{ entity?.bezeichnung }}</div>
      <div class="text-sm opacity-75 text-ellipsis overflow-hidden">{{ entity?.beschreibung }}</div>
    </div>
    <div class="h-full pr-2 w-full min-h-[3rem] hover:bg-secondary-300 flex items-center justify-center flex-grow flex-shrink-0 text-lg cursor-pointer" (click)="edit(entity)">
      <i class="ml-3 fa-regular fa-pen-to-square"></i>
    </div>
  </div>
</ng-template>
